import ReactGA from 'react-ga'
import { useSelector } from 'react-redux'
import { useEffect, loadScript } from 'hooks'
import { isProd } from 'config/api.config'
import useGTM from '@elgorditosalsero/react-gtm-hook'

// *** GA actions - not used atm
const modalEvent = modalName => ReactGA.modalview(modalName)
const gaEvent = (action, category) => ReactGA.event({ action, category })
const attemptedUpgrade = from => gaEvent(from, 'Attempted Upgrade')
const attemptedChat = () => gaEvent('Attempted Chat', 'Chat')
const reportError = (description, fatal = false) => ReactGA.exception({ description: `Error: ${description}`, fatal })

const useGA = (history, gaIds, { gaTracker, gaDebug }) => {
  if (gaTracker) {
    ReactGA.initialize(gaTracker, { debug: gaDebug })
    ReactGA.event({
      category: 'Dev Tests',
      action: 'Tracker test event',
    })
    history.listen(loc => ReactGA.pageview(loc.hostname + loc.pathname + loc.search))
    return
  }

  const nicheTrackerConfig = { trackingId: 'UA-133198904-15' }

  const partnerTrackerConfig = gaIds.split(/[\s,]+/g).map(id => ({
    trackingId: id,
    gaOptions: { name: new Date().getTime() },
  }))

  ReactGA.initialize([nicheTrackerConfig, ...partnerTrackerConfig])
  history.listen(loc => {
    const currentLocation = loc.hostname + loc.pathname + loc.search
    ReactGA.pageview(
      currentLocation,
      partnerTrackerConfig.map(conf => conf.gaOptions.name)
    )
  })
}

const useTracking = history => {
  const { init } = useGTM()
  const gaIds = useSelector(s => s.siteConfig.gaIds) || ''
  const { gaTracker, gaDebug } = useSelector(s => s.flags)

  if (gaTracker) return useGA(history, { gaTracker, gaDebug })
  if (isProd) {
    useEffect(() => {
      useGA(history, gaIds, { gaDebug })
      return init({ id: 'GTM-P4TGBNS' })
    }, [])
    loadScript('https://www.googleoptimize.com/optimize.js?id=OPT-N9FXB3D')
  }
}

export { useTracking as default, useTracking, modalEvent, gaEvent, attemptedUpgrade, attemptedChat, reportError }
